import React from "react";
import DollarNow from "./components/DollarNow";

import "./index.css";
function App() {
  return (
    <div className="App">
      <DollarNow />
    </div>
  );
}

export default App;
